export enum TripStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED   = 'COMPLETED',
  EXPIRED   = 'EXPIRED',
  CANCELLED   = 'CANCELLED',
  PLANNED     = 'PLANNED',
}
